import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

import {styled} from "@mui/system";
import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {getQueryParam} from "helpers/queryParam";

export const StyledAutocomplete = styled(Autocomplete)(({theme}) => ({
    flexDirection: "row",
    fontSize: "14px",

    "&.MuiAutocomplete-root": {
        border: `solid 2px ${theme.palette.disabled.contrastText}`,
        height: "40px",
        borderRadius: theme.shape.borderRadius,
        "& fieldset": {
            border: "none",
            padding: 0,
        },
        ".css-wb57ya-MuiFormControl-root-MuiTextField-root": {
            padding: "0",
            height: "40px",
            "& div": {
                padding: "0 10px 0 0 !important",
                "& div": {
                    left: 9,
                    right: "unset",
                },
                "& input": {
                    right: 0,
                },
            },
        },
    },
}));

export default function TableAutoComplete({
                                              options,
                                              onChange,
                                              queryParam,
                                          }: {
    options: any[];
    onChange: (newValue: any) => void;
    queryParam: string;
}) {
    const [option, setOption] = useState({
        value: getQueryParam(queryParam) || 0,
    });

    //@ts-ignore
    const {token} = useSelector((state) => state).businessReducer.business;

    useEffect(() => {
        onChange(option);
    }, [option, token]);

    return (
        <StyledAutocomplete
            disablePortal
            id="combo-box-demo"
            options={options}
            //   @ts-ignore
            onChange={(event: any, newValue: any) => {
                //   @ts-ignore
                if (newValue) return setOption(newValue);
            }}
            defaultValue={options.find((item) => item.value == option.value)}
            sx={{width: 300}}
            // @ts-ignore
            renderInput={(params) => (
                <TextField
                    style={{padding: 0}}
                    placeholder="انتخاب کنید"
                    {...params}
                    //   label="Movie"
                />
            )}
        />
    );
}
